import { cva, VariantProps } from "class-variance-authority";

export const formControlVariants = cva(
  [
    "outline-none disabled:bg-gray-100 placeholder-gray-400",
    // Hybrid pattern: border visible by default, ring added on hover/focus
    // Border: 1px default, turns black on hover/focus
    // Ring width controlled by CSS variables (--control-ring-width-*)
    "border border-control-border",
    "ring-[length:var(--control-ring-width-base)] ring-control-ring-hover",
    // Hover: black border + ring (width from --control-ring-width-hover)
    "enabled:hover:border-control-border-hover",
    "enabled:hover:ring-[length:var(--control-ring-width-hover)]",
    "enabled:hover:ring-control-ring-hover",
    // Focus: black border + ring (width from --control-ring-width-focus)
    "focus:border-control-border-focus",
    "focus:ring-[length:var(--control-ring-width-focus)]",
    "focus:ring-control-ring-focus",
    // React Aria data attributes for components using data-* APIs
    "data-[focus-within=true]:border-control-border-focus",
    "data-[focus-within=true]:ring-[length:var(--control-ring-width-focus)]",
    "data-[focus-within=true]:ring-control-ring-focus",
    "data-[hovered=true]:border-control-border-hover",
    "data-[hovered=true]:ring-[length:var(--control-ring-width-hover)]",
    "data-[hovered=true]:ring-control-ring-hover",
  ],
  {
    variants: {
      vColor: {
        pristine: [],
        dirty: [
          "border-control-border-dirty",
          "ring-control-ring-dirty",
          "focus:ring-control-ring-dirty",
          "enabled:hover:ring-control-ring-dirty",
          "data-[hovered=true]:ring-control-ring-dirty",
          "data-[focus-within=true]:ring-control-ring-dirty",
        ],
        error: [
          "border-control-border-error",
          "ring-control-ring-error",
          "focus:ring-control-ring-error",
          "enabled:hover:ring-control-ring-error",
          "data-[hovered=true]:ring-control-ring-error",
          "data-[focus-within=true]:ring-control-ring-error",
        ],
      },
      vSize: {
        sm: ["min-h-form-sm py-1 px-2 text-sm rounded-form-sm"], //31px
        md: ["min-h-form-md py-1 px-3 text-base rounded-form-md"], //38px
        lg: "min-h-form-lg py-1 px-4 text-lg rounded-form-lg", //48px
      },
    },
    defaultVariants: {
      vColor: "pristine",
      vSize: "md",
    },
  },
);

export type FormControlVariantsProps = VariantProps<typeof formControlVariants>;

export const formControlSizes = cva(
  [
    // common
    //outline
  ],
  {
    variants: {
      size: {
        sm: ["h-form-sm py-1 px-2 text-sm rounded-form-sm"], //31px
        md: ["h-form-md py-1 px-3 text-base rounded-form-md"], //38px
        lg: "h-form-lg py-1 px-4 text-lg rounded-form-lg", //48px
        unset: "",
      },
    },
    defaultVariants: { size: "md" },
  },
);

export const formTextSizes = cva([], {
  variants: {
    vSize: {
      sm: ["text-sm"],
      md: ["text-base"],
      lg: ["text-lg"],
    },
  },
  defaultVariants: { vSize: "md" },
});
